import {CompanyCustomerVM} from "./CompanyCustomerVM.model";
import {CompanyCustomFormVM} from "./CompanyCustomFormVM.model";
import {IntakeFormVM} from "./IntakeForm.model";
import {IntakeFormDataVM} from "./IntakeFormDataVM.model";

export class CompanyCustomerFormDataVM {
  id: number;
  intakeData: string;
  companyCustomerId: number;
  companyCustomer: CompanyCustomerVM;
  companyCustomFormId: number;
  companyCustomForm: CompanyCustomFormVM;
  intakeDataDTO: any;

  constructor() {
    this.id= null;
    this.intakeData= null;
    this.companyCustomerId= null;
    this.companyCustomer= null;
    this.companyCustomFormId= null;
    this.companyCustomForm= null;
    this.intakeDataDTO= null;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/CompanyCustomerFormDataVM.model.ts